import { useEffect } from "react";

function NotFound() {
    window.location.replace('/404');
    return <div/>
}
export default NotFound;